module.exports = __webpack_public_path__ + "img/media-4.44b7f7d4.jpg";